import { render, staticRenderFns } from "./OnsiteIcon.vue?vue&type=template&id=07be8e33&scoped=true"
import script from "./OnsiteIcon.vue?vue&type=script&lang=js"
export * from "./OnsiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be8e33",
  null
  
)

export default component.exports